import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { FieldsetModule } from "primeng/fieldset";
import { AddressViewComponent } from "./address-view.component";
import { FieldsetAriaFixDirective } from "@shared/directives/fieldset-area-fix.directive";

@NgModule({
  declarations: [],
  imports: [
    FieldsetModule,
    TranslateModule,
    CommonModule,
    FieldsetAriaFixDirective,
    AddressViewComponent
  ],
  exports: [AddressViewComponent]
})
export class AddressViewModule {}
